<!--
  活动进来选商品是这个页
  /web/seckill-public?multipleTopicId=85
  /web/topic-detail?topicId=88&buyFlag=1
-->

<template>
  <div v-wechat-title="topicTitle" class="classify-page">
    <div class="content-box">
      <div class="box1">
        <van-search v-model="keyword" placeholder="输入关键字搜索商品 ^" shape="round" @search="getGoodsByCateName" />
      </div>
      <van-image v-if="adsImage" :src="adsImage" height="100" lazy-load></van-image>

      <div v-if="navList && navList.length > 0" style="padding: 0 8px">
        <div style="background-color: #ffffff; line-height: 40px; margin-top: 8px">
          <span style="font-size: 12px; margin-left: 8px">分类筛选：</span>
          <van-tag v-for="(item, index) of navList" :key="index" :plain="cateName !== item.name" size="large"
            style="margin: 0 8px" type="primary" @click="navChange(item.name)">{{ item.name }}
          </van-tag>
        </div>
      </div>

      <div class="box2 flex-row">
        <div class="goods-box">
          <div v-for="item of goodsList" :key="item.id" class="goods-item flex-row col-center mt5">
            <goods-unit v-if="buyFlag == 1" :goods-id="item.id" :goods-style="9" :head-image="item.headImage"
              :name="item.name" :price="item.price" :sale-count="item.sale" :spec="item.spec" :tags="item.tags"
              :topic-id="topicId" :visible-buy-button="visibleBuyButton" :visible-price="visiblePrice"></goods-unit>

            <goods-unit v-else :goods-id="item.id" :head-image="item.headImage" :name="item.name" :price="item.price"
              :sale-count="item.sale" :spec="item.spec" :tags="item.tags" :visible-buy-button="visibleBuyButton"
              :visible-price="visiblePrice"></goods-unit>
          </div>
        </div>
      </div>
    </div>

    <van-popup v-model="showAdsImage" style="background: none">
      <div style="text-align: center">
        <van-image :src="adsImageSrc" width="300" @click="adsImageTargetUrl ? $router.push(adsImageTargetUrl) : ''" />
        <van-icon color="#f5f5f5" name="close" size="42" style="margin-top: 32px" @click="showAdsImage = false" />
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { wx_get_goods_list_by_topic, get_topic_by_id } from "@/api/goods-api";
import GoodsUnit from "@/components/common/goods-unit";
import { Lazyload } from "vant";
import { getSysConfigValue } from "@/api/sys-api";

Vue.use(Lazyload);

export default {
  name: "index",

  components: { GoodsUnit },

  data() {
    return {
      hotGoodsCate: [],
      cateAdsImage: "",
      keyword: "",
      navActive: 0,
      navList: [],
      goodsList: [],
      topicId: 0,
      topicTitle: "",
      adsImage: "",
      cateName: "",

      /**
       * 是否直接购买：1=不显示商品详情链接，不加入购物车，直接购买
       */
      buyFlag: 0,
      visiblePrice: 1,
      showAdsImage: false,
      adsImageSrc: "",
      adsImageTargetUrl: "",
      visibleBuyButton: 1,
    };
  },

  created() {
    this.topicId = parseInt(this.$route.query.topicId.toString()) || 0;
    this.buyFlag = this.$route.query.buyFlag || 0;
    this.visibleBuyButton = this.topicId === 12 ? 0 : 1;

    get_topic_by_id(this.topicId).then((res) => {
      budo_log.info("#102 created get_topic_by_id", res);
      this.topicTitle = res.data.name;
      this.adsImage = res.data.adsImage;
      this.visiblePrice = res.data.visiblePrice;
      if (res.data.cate && res.data.cate.length > 0) {
        this.navList = res.data.cate.map((c) => {
          return { name: c };
        });
      }

      budo_log.info("#113 created get_topic_by_id", this.navList.length > 0);
    });

    this.getGoodsByCateName();

    // 地方特色专题弹出广告 仅 12 这个专题有
    if (this.topicId === 12) {
      if (!sessionStorage.getItem("store_topic_ads_show_flag_12")) {
        // 只弹一次
        getSysConfigValue("Topic_Ads_12_Image").then((res) => {
          this.adsImageSrc = res.data;
          if (res.data && res.data.length > 0) {
            sessionStorage.setItem("store_topic_ads_show_flag_12", 1);
            this.showAdsImage = true;
          }
        });

        getSysConfigValue("Topic_Ads_12_Target").then((res) => {
          this.adsImageTargetUrl = res.data;
        });
      }
    }
  },

  methods: {
    //分类改变
    navChange(e) {
      this.cateName = this.cateName === e ? "" : e;
      this.getGoodsByCateName(this.cateName);
    },

    getGoodsByCateName() {
      wx_get_goods_list_by_topic(
        this.topicId,
        [this.cateName],
        1,
        500,
        this.keyword
      ).then((res) => {
        this.goodsList = res.data.records.map((item) => {
          return {
            id: item.goodsId,
            name: item.name,
            price: item.price,
            sale: item.saleCount,
            headImage: item.headImage,
            spec: item.spec,
            tags: item.tags ? JSON.parse(item.tags) : [],
          };
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "index";
</style>
